import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Flex } from 'antd';

import ImgPreview1 from '@/shared/pictures/preview1.jpg';
import ImgPreview2 from '@/shared/pictures/preview2.jpg';
import ImgPreview3 from '@/shared/pictures/preview3.jpg';

import BannerTop from '@/shared/pictures/banner_top.png';
import BannerBottom from '@/shared/pictures/banner_bottom.png';
import { CustomVideo } from '@/shared/ui/CustomVideo';

export const TrainingPage = observer(() => {
  return (

    <div className="training-page">
      <div className="training-page_banner">

        <div className="container">
          <img src={BannerTop} alt="img1"/>

          <h2 className='training-page_banner-title'>Тренировки <span>Ови</span></h2>

          <p className='training-page_banner-text'>{'Вводные тренировки от Александра Овечкина \nи его личного тренера Павла Бурлаченко. \nВы узнаете, как готовится к сезону легенда, \nна какие упражнения делает упор, что нравится \nи что не нравится в подготовке.'}</p>

          <Flex className='video-blocks' vertical gap={20} style={{marginBottom:'-100px',zIndex: '2',position: 'relative'}}>  
            <CustomVideo url='https://9853f2d2-a39597f0-8b31-4443-a6ce-b8805ec96ff2.s3.twcstorage.ru/trainigs/1a.mp4' poster={ImgPreview1}/> 
            <CustomVideo url='https://9853f2d2-a39597f0-8b31-4443-a6ce-b8805ec96ff2.s3.twcstorage.ru/trainigs/2a.mp4' poster={ImgPreview2}/> 
            <CustomVideo url='https://9853f2d2-a39597f0-8b31-4443-a6ce-b8805ec96ff2.s3.twcstorage.ru/trainigs/3a.mp4' poster={ImgPreview3}/> 
          </Flex>
  
          <div className='training-page_banner-bottom'>
            <Flex justify='space-between' align='center' style={{position: 'absolute',bottom: '10px',width: '100%'}}>
              <a href='https://fonbet.onelink.me/Ci45/a7l4xykf' target='_blank' className='training-page_banner-button' >Скачать приложение</a>
              <p className='training-page_banner-copyright'>
                © Букмекерская компания
                <br/>
                FON.BET. 2025 18+
              </p>
            </Flex>
            <img src={BannerBottom} alt="img2"/>
          </div>
          
        </div>

      </div>
      
    </div>
  );
});